import { useState, useCallback } from 'react';
import { consumirApi } from '../../../../utils/consumoApi';
import { debounce } from 'lodash';

const useUbicaciones = () => {
  const [ubicaciones, setUbicaciones] = useState([]);
  const [busquedaUbicacion, setBusquedaUbicacion] = useState('');
  const [ubicacionGeneral, setUbicacionGeneral] = useState('');
  const [idUbicacion, setIdUbicacion] = useState('');
  const [costoUbicacion, setCostoUbicacion] = useState('');
  const [mostrarModalSeleccionarUbicacion, setMostrarModalSeleccionarUbicacion] = useState(false);
  const idEmpresa = JSON.parse(localStorage.getItem('empresa'))

  // Crear la función debounced utilizando useCallback
  const realizarConsultaDebouncedUbicacion = useCallback(
    debounce(async (ubicacion) => {
      if (ubicacion.trim() === '') {
        setUbicaciones([]);
      } else {
        const respuesta = await consumirApi('GET', `maestros/ubicacion/buscar/${idEmpresa}/${ubicacion}`);
        setUbicaciones(respuesta.success ? respuesta.data : respuesta.error);
      }
    }, 300),
    [] // Solo se crea una vez
  );

  // Función para mostrar el modal de selección de ubicación
  const seleccionarUbicacion = (e) => {
    e.preventDefault();
    setMostrarModalSeleccionarUbicacion(true);
  };

  // Maneja la búsqueda de ubicaciones según el texto ingresado
  const manejarBusquedaUbicacion = (ubicacion) => {
    setBusquedaUbicacion(ubicacion);
    realizarConsultaDebouncedUbicacion(ubicacion);
  };

  // Selecciona una ubicación del listado de sugerencias y carga los datos
  const manejarSeleccionUbicacion = (data) => {
    setUbicacionGeneral(data.ciudad);
    setIdUbicacion(data.id);
    setCostoUbicacion(data.costo_viatico);
    limpiarCamposUbicaciones();
  };

  // Limpiar campos
  const limpiarCamposUbicaciones = () => {
    setBusquedaUbicacion('');
    setUbicaciones([]);
    setMostrarModalSeleccionarUbicacion(false);
  };

  return {
    ubicaciones,
    busquedaUbicacion,
    ubicacionGeneral,
    idUbicacion,
    costoUbicacion,
    mostrarModalSeleccionarUbicacion,
    seleccionarUbicacion,
    manejarBusquedaUbicacion,
    manejarSeleccionUbicacion,
    limpiarCamposUbicaciones
  };
};

export default useUbicaciones;
